import { render, staticRenderFns } from "./estatusImportacionModal.vue?vue&type=template&id=5c48c12f"
import script from "./estatusImportacionModal.vue?vue&type=script&lang=js"
export * from "./estatusImportacionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports